import { Divider, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getPrompt } from '../../hooks/prompts';

export default function Content() {
  const { hash } = useLocation();
  const [item, setItem] = useState(null);

  const id = useMemo(() => hash?.replace('#', ''), [hash]);
  useEffect(() => {
    setItem(null);
    if (!id) return;
    getPrompt(id)
      .then((data) => setItem(data))
      .catch((error) => console.error(`Failed to get prompt ${id}:`, error));
  }, [id]);

  if (!item) return null;
  return (
    <>
      <Typography variant="body1" fontSize={24} fontWeight={500}>
        {item.title}
      </Typography>
      <Divider />
      <Typography sx={{ whiteSpace: 'pre-wrap' }}>
        {item.description}
      </Typography>
    </>
  );
}
